import actions from "./favListings.actions";

export const initialState = {
  userLikes: {},
};

export default function favListingsReducer(state, action) {
  switch (action.type) {
    case actions.SET_FAV_LISTINGS:
      return {
        ...state,
        ...action.payload,
      };
    case actions.ADD_FAV_LISTING:
      return {
        ...state,
        [action.payload]: true,
      };
    case actions.REMOVE_FAV_LISTING: {
      const { [action.payload]: removed, ...rest } = state;
      return {
        ...rest,
      };
    }
    case actions.SET_USER_LIKES:
      return {
        ...state,
        userLikes: action.payload,
      };
    case actions.ADD_LIKE: {
      return {
        ...state,
        userLikes: {
          ...state.userLikes,
          [action.payload]: {
            listing_id: action.payload,
            created_at: Date.now(),
          },
        },
      };
    }
    case actions.REMOVE_LIKE: {
      const { [action.payload]: removed, ...rest } = state.userLikes;
      return {
        ...state,
        userLikes: {
          ...rest,
        },
      };
    }
    case actions.SET_FETCH_LIKES_COMPLETED:
      return {
        ...state,
        fetchLikesCompleted: action.payload,
      };
    default:
      throw new Error("Unsupported action type at fav listings reducer");
  }
}
